<template>
    <form class="f-form-newsletter" v-on:submit.prevent="onSubmit">
        <fieldset class="f-form-newsletter__fieldset">

            <div class="f-form-newsletter__holder">
                <input type="email" placeholder="Vložte váš e-mail…" class="f-form-newsletter__input" v-model="email">
                <button type="submit" class="e-button e-button--light-blue f-form-newsletter__submit">
                    {{processing ? 'Odesílám...' : 'Chci novinky'}}
                </button>
            </div>

            <div class="f-form-newsletter__holder">
                <label class="e-checkbox">
                    <input type="checkbox" id="agree" class="e-checkbox__native" name="agree" v-model="agree">
                    <span class="e-checkbox__control"></span>
                    <span class="e-checkbox__label">
                        <span class="e-checkbox__text">
                            <a href="/zpracovani-osobnich-udaju-pro-marketingove-ucely/" class="e-checkbox__link" target="_blank" title="Souhlas se zpracováním osobních údajů k marketingovým účelům">Mám zájem o produktové informace, montážní postupy či doporučení a další sdělení.</a>
                        </span>
                    </span>
                </label>
            </div>

            <div v-if="errors.length">
                <div class="e-message e-message__error" v-for="error in errors">{{error.message}}</div>
            </div>

            <div class="e-message e-message__success" v-if="success">
                Formulář byl odeslán
            </div>

        </fieldset>
    </form>
</template>

<script>
    import {sign} from './api/sign';
    import filter from 'lodash/filter';
    import {isEmail} from '../../helpers/validation';

    function initialState() {
        return {
            processing: false,
            email:      '',
            agree:      false,
            errors:     [],
            success:    false,
        }
    }

    export default {
        name:    'NewsletterForm',
        data() {
            return initialState()
        },
        methods: {
            onSubmit() {
                if (false == this.validate('input')) {
                    this.processing = true;
                    sign(this.prepareData())
                        .then(() => {
                            this.reset();
                            this.successForm();
                        })
                        .catch(() => this.errors.push({
                            message: 'Formulář se nepodařilo odeslat, zkuste to znovu',
                            type:    'request'
                        }))
                        .finally(() => this.processing = false)
                }
            },
            validate(type) {
                this.errors = [];
                if (!isEmail(this.email)) {
                    this.errors.push({ message: 'E-mail není ve správném tvaru', type: 'input' });
                }
                if (this.agree === false) {
                    this.errors.push({ message: 'Musíte souhlasit se zpracováním osobních údajů', type: 'input' });
                }
                return filter(this.errors, error => error.type === type).length;
            },
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this));
            },
            successForm() {
                this.success = true;
                setTimeout(() => this.success = false, 10000);
            },
            prepareData() {
                return {
                    email: this.email,
                };
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/newsletter/Form.vue